import { useEffect } from 'react';
import moment from 'moment';
import 'moment/locale/fr';
import useCookies from '@commonClient2/hooks/useCookies';
import i18n, { setLocale, getLocale } from '@services/i18n';

const domainName = 'zaddons.com';

/**
 *
 * @returns
 */
const useAppLanguage = () => {
    const isMultiLanguage = sessionStorage.getItem('isMultiLanguage');
    const { cookies = {}, setCookie } = useCookies(domainName);
    const { language } = cookies;

    useEffect(() => {
        if (language) {
            i18n.changeLanguage(language);
            setLocale(language);
            moment.locale(language);
            return;
        }

        const jwtLanguageCode = sessionStorage.getItem('jwtLanguageCode');
        if (jwtLanguageCode) {
            i18n.changeLanguage(jwtLanguageCode);
            setLocale(jwtLanguageCode);
            moment.locale(jwtLanguageCode);
            setCookie('language', jwtLanguageCode);
            return;
        }

        if (isMultiLanguage) {
            i18n.changeLanguage(getLocale().code);
            const lang = i18n.language.includes('en') ? 'en' : 'fr';
            setLocale(lang);
            moment.locale(lang);
            setCookie('language', lang);

            return;
        }

        i18n.changeLanguage('en');
        setLocale('en');
        moment.locale('en');
        setCookie('language', 'en');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language, isMultiLanguage]);

    const isEnglish = i18n.language.includes('en');
    const currentLanguage = i18n.language;
    const nextLanguage = isEnglish ? 'fr' : 'en';

    const changeLanguage = (toLanguage) => {
        if (currentLanguage === toLanguage) { return; }
        i18n.changeLanguage(toLanguage);
        setLocale(toLanguage);
        moment.locale(toLanguage);
        setCookie('language', toLanguage);
    };

    return {
        isMultiLanguage, changeLanguage, currentLanguage, nextLanguage,
    };
};

export default useAppLanguage;
